import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { handleActions } from 'redux-actions';
import { fetchArtAuthorSuccess } from './actions';
import { reduxKey } from './constants';
const defaultState = {
    artAuthor: undefined
};
const handleFetchPopupArtAuthorSuccess = (state, { payload })=>{
    const { user } = payload;
    return _object_spread_props(_object_spread({}, state), {
        artAuthor: user
    });
};
const reducer = handleActions({
    [fetchArtAuthorSuccess.toString()]: handleFetchPopupArtAuthorSuccess
}, defaultState);
export default {
    [reduxKey]: reducer
};

//# sourceMappingURL=reducers.js.map